import React from 'react';

export function Loading() {
  return (
    <div className='p-loading'>
      <div className='p-loading__indicator' />
    </div>
  );
}
